import { Component, EventEmitter, Output } from '@angular/core';
import { FormArray, FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GenericModalComponent } from '@app/helpers/generic-modal-component';
import { EmployeeService } from '@app/services/employee.service';
import { UserService } from '@app/services/user.service';
import { status_code } from 'functions/src/help/status-query';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
  selector: 'modal-bar-employee-substitution',
  templateUrl: './modal-bar-employee-substitution.component.html'
})
export class ModalBarEmployeeSubstitutionComponent extends GenericModalComponent {

  @Output() eventCancel = new EventEmitter<any>();
  public substituteEnabled: boolean = false;
  public isButtonSubmitEnabled: boolean = false;
  private currentLength: number = 0;

  constructor(
    private employeeService: EmployeeService,
    private userService: UserService) {


    super('modal-employee-substitution', 'form-carousel-employee-substitution');
    this.arrayHourSubstitution = this.getArrayHourSubstitution();

    this._formGroupModal = new FormGroup({
      employeeSubstitution: new UntypedFormControl(null),
      hourSubstitutionMon: new UntypedFormArray([]),
      hourSubstitutionTue: new UntypedFormArray([]),
      hourSubstitutionWed: new UntypedFormArray([]),
      hourSubstitutionThu: new UntypedFormArray([]),
      hourSubstitutionFri: new UntypedFormArray([]),
    })

    this.arrayHourSubstitution.mon.forEach(e => {
      this.hourSubstitutionMon.push(new UntypedFormControl(false))
      this.hourSubstitutionTue.push(new UntypedFormControl(false))
      this.hourSubstitutionWed.push(new UntypedFormControl(false))
      this.hourSubstitutionThu.push(new UntypedFormControl(false))
      this.hourSubstitutionFri.push(new UntypedFormControl(false))
    });

    this.subscribeTimeStot();
  }

  public arrayHourSubstitution = { mon: [], tue: [], wed: [], thu: [], fri: [] };

  public selectionAllMon: Boolean = false;
  public selectionAllTue: Boolean = false;
  public selectionAllWed: Boolean = false;
  public selectionAllThu: Boolean = false;
  public selectionAllFri: Boolean = false;

  private subscriptionHourSubstitutionMon: Subscription;
  private subscriptionHourSubstitutionTue: Subscription;
  private subscriptionHourSubstitutionWed: Subscription;
  private subscriptionHourSubstitutionThu: Subscription;
  private subscriptionHourSubstitutionFri: Subscription;

  resetValues() {

    this.unsubscribeTimeStot();

    this.selectionAllMon = false;
    this.selectionAllTue = false;
    this.selectionAllWed = false;
    this.selectionAllThu = false;
    this.selectionAllFri = false;

    this.hourSubstitutionMon.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionTue.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionWed.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionThu.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionFri.controls.forEach(e => e.setValue(false));

    this.subscribeTimeStot();
  }

  subscribeTimeStot() {
    this.subscriptionHourSubstitutionMon = this.hourSubstitutionMon.valueChanges.subscribe(() => { this.changeValueHour('mon') });
    this.subscriptionHourSubstitutionTue = this.hourSubstitutionTue.valueChanges.subscribe(() => { this.changeValueHour('tue') });
    this.subscriptionHourSubstitutionWed = this.hourSubstitutionWed.valueChanges.subscribe(() => { this.changeValueHour('wed') });
    this.subscriptionHourSubstitutionThu = this.hourSubstitutionThu.valueChanges.subscribe(() => { this.changeValueHour('thu') });
    this.subscriptionHourSubstitutionFri = this.hourSubstitutionFri.valueChanges.subscribe(() => { this.changeValueHour('fri') });
  }

  unsubscribeTimeStot() {
    if (this.subscriptionHourSubstitutionMon) { this.subscriptionHourSubstitutionMon.unsubscribe(); };
    if (this.subscriptionHourSubstitutionTue) { this.subscriptionHourSubstitutionTue.unsubscribe(); };
    if (this.subscriptionHourSubstitutionWed) { this.subscriptionHourSubstitutionWed.unsubscribe(); };
    if (this.subscriptionHourSubstitutionThu) { this.subscriptionHourSubstitutionThu.unsubscribe(); };
    if (this.subscriptionHourSubstitutionFri) { this.subscriptionHourSubstitutionFri.unsubscribe(); };
  }

  changeValueHour(day: string) {
    let fa: UntypedFormArray = null;
    let newVal = true;
    switch (day) {
      case 'mon': fa = this.hourSubstitutionMon; break;
      case 'tue': fa = this.hourSubstitutionTue; break;
      case 'wed': fa = this.hourSubstitutionWed; break;
      case 'thu': fa = this.hourSubstitutionThu; break;
      case 'fri': fa = this.hourSubstitutionFri; break;
    }
    if (fa === null) { return; }
    for (let index = 0; index < fa.controls.length; index++) {
      const e = fa.controls[index];
      if (e.value !== true) {
        newVal = false;
        break;
      }
    }
    switch (day) {
      case 'mon': this.selectionAllMon = newVal; break;
      case 'tue': this.selectionAllTue = newVal; break;
      case 'wed': this.selectionAllWed = newVal; break;
      case 'thu': this.selectionAllThu = newVal; break;
      case 'fri': this.selectionAllFri = newVal; break;
    }

    this.isButtonSubmitEnabled = this.values().length > 0 ? true : false;
  }

  onCheckChangeDay(event: any, day: string) {
    let fa: UntypedFormArray = null;
    let newVal = null;
    switch (day) {
      case 'mon': fa = this.hourSubstitutionMon; break;
      case 'tue': fa = this.hourSubstitutionTue; break;
      case 'wed': fa = this.hourSubstitutionWed; break;
      case 'thu': fa = this.hourSubstitutionThu; break;
      case 'fri': fa = this.hourSubstitutionFri; break;
    }
    if (event.target.checked) { newVal = true } else { newVal = false }
    if (fa === null || newVal === null) { return; }
    fa.controls.forEach((c: UntypedFormControl) => {
      c.setValue(newVal)
    });
    switch (day) {
      case 'mon': this.selectionAllMon = newVal; break;
      case 'tue': this.selectionAllTue = newVal; break;
      case 'wed': this.selectionAllWed = newVal; break;
      case 'thu': this.selectionAllThu = newVal; break;
      case 'fri': this.selectionAllFri = newVal; break;
    }

    this.isButtonSubmitEnabled = this.values().length > 0 ? true : false;
  }

  populate(arrValues: Array<any>) {
    this.unsubscribeTimeStot();

    this.hourSubstitutionMon.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionTue.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionWed.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionThu.controls.forEach(e => e.setValue(false));
    this.hourSubstitutionFri.controls.forEach(e => e.setValue(false));

    arrValues.forEach((e: any) => {

      switch (e.day) {
        case "mon":
          this.hourSubstitutionMon.at(this.arrayHourSubstitution.mon.findIndex(x => x.hour === parseInt(e.hour))).setValue(true);
          break;
        case "tue":
          this.hourSubstitutionTue.at(this.arrayHourSubstitution.mon.findIndex(x => x.hour === parseInt(e.hour))).setValue(true);
          break;
        case "wed":
          this.hourSubstitutionWed.at(this.arrayHourSubstitution.mon.findIndex(x => x.hour === parseInt(e.hour))).setValue(true);
          break;
        case "thu":
          this.hourSubstitutionThu.at(this.arrayHourSubstitution.mon.findIndex(x => x.hour === parseInt(e.hour))).setValue(true);
          break;
        case "fri":
          this.hourSubstitutionFri.at(this.arrayHourSubstitution.mon.findIndex(x => x.hour === parseInt(e.hour))).setValue(true);
          break;
      }
    });
    this.subscribeTimeStot();

    if (arrValues.length > 0) {
      this.changeValueHour('mon')
      this.changeValueHour('tue')
      this.changeValueHour('wed')
      this.changeValueHour('thu')
      this.changeValueHour('fri')
    }

    this.currentLength = this.values().length;

    this.isButtonSubmitEnabled = this.currentLength > 0 ? true : false;
  }

  values() { return this.getFormGroupSubstituionValuess(this._formGroupModal, this.arrayHourSubstitution); }

  getFormGroupSubstituionValuess(fg: UntypedFormGroup, arr: { mon: any[]; tue: any[]; wed: any[]; thu: any[]; fri: any[]; }) {

    let values = [];

    const selectedMon = fg.get("hourSubstitutionMon").value.map((v, i) => v ? arr.mon[i].hour : null).filter(v => v !== null);
    const selectedTue = fg.get("hourSubstitutionTue").value.map((v, i) => v ? arr.tue[i].hour : null).filter(v => v !== null);
    const selectedWed = fg.get("hourSubstitutionWed").value.map((v, i) => v ? arr.wed[i].hour : null).filter(v => v !== null);
    const selectedThu = fg.get("hourSubstitutionThu").value.map((v, i) => v ? arr.thu[i].hour : null).filter(v => v !== null);
    const selectedFri = fg.get("hourSubstitutionFri").value.map((v, i) => v ? arr.fri[i].hour : null).filter(v => v !== null);

    Array.from(selectedMon).forEach(e => { values.push({ day: 'mon', hour: e }) });
    Array.from(selectedTue).forEach(e => { values.push({ day: 'tue', hour: e }) });
    Array.from(selectedWed).forEach(e => { values.push({ day: 'wed', hour: e }) });
    Array.from(selectedThu).forEach(e => { values.push({ day: 'thu', hour: e }) });
    Array.from(selectedFri).forEach(e => { values.push({ day: 'fri', hour: e }) });

    return values;

  }


  getArrayHourSubstitution(): { mon: any[]; tue: any[]; wed: any[]; thu: any[]; fri: any[]; } {

    var arr = { mon: [], tue: [], wed: [], thu: [], fri: [] };

    for (let vhour = 8; vhour <= 16; vhour++) {

      var vlabel = "";

      if (vhour < 9) {
        vlabel += "0" + vhour + " - 0" + (vhour + 1);
      }
      else if (vhour < 10) {
        vlabel += "0" + vhour + " - " + (vhour + 1);
      }
      else {
        vlabel += vhour + " - " + (vhour + 1);
      }

      arr.mon.push({ id: 'mon' + vhour, day: 'mon', hour: vhour, label: vlabel })
      arr.tue.push({ id: 'tue' + vhour, day: 'tue', hour: vhour, label: vlabel })
      arr.wed.push({ id: 'wed' + vhour, day: 'wed', hour: vhour, label: vlabel })
      arr.thu.push({ id: 'thu' + vhour, day: 'thu', hour: vhour, label: vlabel })
      arr.fri.push({ id: 'fri' + vhour, day: 'fri', hour: vhour, label: vlabel })
    }

    return arr;
  }



  onClickSubmitButton(event: MouseEvent) {

    event.preventDefault();

    this.employeeService.postSubstitutionRange(this.userService.getIdEmployee(), this.values()).toPromise().then((res: any) => {

      if (res.status_code === status_code.success) {
        this.showStepSuccess();

        this.currentLength = this.values().length;

        return;
      }
      this.showStepError();
    },
      err => {
        this.showStepError();
        console.error(err);
      }
    );

  }

  actionOpenModal(event: MouseEvent | undefined) {

    if (event)
      event.preventDefault();

    this.resetStepCarousel();
    this.modalShow();
  }

  setSubstituteEnabled(value: boolean) {
    this.substituteEnabled = value;
  }

  onCancel(event: MouseEvent) {
    event.preventDefault();

    if (this.currentLength === 0) {
      this.eventCancel.next(undefined);
    }

  }

  get hourSubstitutionMon() { return (this._formGroupModal.get('hourSubstitutionMon') as FormArray); }
  get hourSubstitutionTue() { return (this._formGroupModal.get('hourSubstitutionTue') as FormArray); }
  get hourSubstitutionWed() { return (this._formGroupModal.get('hourSubstitutionWed') as FormArray); }
  get hourSubstitutionThu() { return (this._formGroupModal.get('hourSubstitutionThu') as FormArray); }
  get hourSubstitutionFri() { return (this._formGroupModal.get('hourSubstitutionFri') as FormArray); }
}